import {useRef} from 'react'
import Slider from 'react-slick'
import {Item} from './Item'
import st from './Agent.module.scss'
import {splitData} from 'helpers'
import arrowLf from 'assets/images/svg/arrow-lft.svg'
import arrowRg from 'assets/images/svg/arrow-rg.svg'

const Arrow = ({ direct, onClick }) => {
    const option = {
        cl: { prev: st.slick_prev, next: st.slick_next },
        icon: { prev: arrowLf, next: arrowRg }
    }

    return (
        <button className={option.cl[direct] + ' slick-arrow' } onClick={onClick}>
            <picture>
                <img src={option.icon[direct]} alt=""/>
            </picture>
        </button>
    )
}

const Dots = ({ dots, changeByDot }) => (
    <ul className={st.slick_dots}>
        {dots.map((p, i) => {
            const cl = p._owner.pendingProps.currentSlide === i ? st.slick_active : null
            return <li key={i} className={cl} onClick={changeByDot(i)} />
        })}
    </ul>
)

const SliderContainer = ({ data, className }) => {
    const refer = useRef(null)
    const changePrev = () => refer.current.slickPrev()
    const changeNext = () => refer.current.slickNext()
    const changeByDot = idx => ()=> refer.current.slickGoTo(idx)

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        appendDots: dots => (
            <div className={st.slick_nav}>
                <Arrow onClick={changePrev} direct="prev"/>
                <Dots dots={dots} changeByDot={changeByDot} />
                <Arrow onClick={changeNext} direct="next"/>
            </div>
        ),
        dotsClass: st.slick_nav,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ]
    }
    return (
        <Slider ref={refer} className={className} {...settings}>
            {data?.map(person => <Item key={person.id} data={person}  />)}
        </Slider>
    )
}

export const WithSlider = ({ data })=> {
    const [top, bottom] = splitData(data, 2)
    return (
        <div className="wrapper">
            <SliderContainer data={top} className={st.top} />
            <SliderContainer data={bottom} className={st.bottom} />
        </div>
    )
}
